import {
  UserManagementFormIndexValueMapping,
  UserManagementMapping,
  UserManagementMeta,
} from './account-user-management.type';

export type AccountAD = {
  id?: string;
  active: boolean;
  config: AccountADConfig;
  mapping: UserManagementMapping[];
  meta?: UserManagementMeta;
  attributesMap?: {
    azureField: AzureAdField;
    entityField: ADEntityField | null;
    synced: boolean;
  }[];
  managerFieldSynced?: boolean;
};

export type AccountADConfig = {
  clientId: string;
  clientSecret?: string;
  hasClientSecret?: boolean;
  tenantId: string;
  checkActiveDirectoryEnabledStatus?: boolean;
};

export enum ADEntityField {
  USERNAME = 'username',
  EMAIL = 'email',
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  LANGUAGE = 'language',
  ACTIVE = 'active',
  COMPANY_DATA_COMPANY_NAME = 'companyData.companyName',
  COMPANY_DATA_DEPARTMENT = 'companyData.department',
  COMPANY_DATA_JOB_TITLE = 'companyData.jobTitle',
  COMPANY_DATA_COUNTRY = 'companyData.country',
  COMPANY_DATA_OFFICE_LOCATION = 'companyData.officeLocation',
  COMPANY_DATA_MOBILE_PHONE = 'companyData.mobilePhone',
  COMPANY_DATA_MANAGER = 'companyData.manager',
  META_EXTERNAL_SYNC_ID = 'meta.externalSyncId',
}

export enum AzureAdField {
  ID = 'id',
  MAIL = 'mail',
  GIVEN_NAME = 'givenName',
  SURNAME = 'surname',
  USER_PRINCIPAL_NAME = 'userPrincipalName',
  PREFERRED_LANGUAGE = 'preferredLanguage',
  JOB_TITLE = 'jobTitle',
  DEPARTMENT = 'department',
  COMPANY_NAME = 'companyName',
  ACCOUNT_ENABLED = 'accountEnabled',
  MANAGER = 'manager',
  COUNTRY = 'country',
  MOBILE_PHONE = 'mobilePhone',
  OFFICE_LOCATION = 'officeLocation',
  DISPLAY_NAME = 'displayName',
  EMPLOYEE_ID = 'employeeId',
  EMPLOYEE_TYPE = 'employeeType',
  CITY = 'city',
  STATE = 'state',
  STREET_ADDRESS = 'streetAddress',
  POSTAL_CODE = 'postalCode',
  USAGE_LOCATION = 'usageLocation',
  BUSINESS_PHONES = 'businessPhones',
  FAX_NUMBER = 'faxNumber',
  MAIL_NICKNAME = 'mailNickname',
  LOCALE = 'locale',
  USER_TYPE = 'userType',
  CREATED_DATE_TIME = 'createdDateTime',
  LAST_PASSWORD_CHANGE_DATE_TIME = 'lastPasswordChangeDateTime',
  PASSWORD_POLICIES = 'passwordPolicies',
}

export type AccountADRequest = {
  active: boolean;
  config?: AccountADConfig;
  mapping?: {
    groupId: string;
    branches: { id: string }[];
    groups: { id: string }[];
    language?: string | null;
  }[];
  attributesMap?: {
    azureField: AzureAdField;
    entityField: ADEntityField | null;
    synced: boolean;
  }[];
};

export type UpdateAccountADRequest = {
  accountId: string;
  updates: AccountADRequest;
};

export type AccountADFormValues = {
  active: boolean;
  clientId: string;
  clientSecret?: string;
  hasClientSecret?: boolean;
  tenantId: string;
  mapping: UserManagementFormIndexValueMapping;
  hasAd?: boolean;
  checkActiveDirectoryEnabledStatus?: boolean;
};
